export enum FeatureFlagsEnum {
  WebsiteBlog = 'WebsiteBlog',
  Diagnostics = 'Diagnostics',
  WebsiteNewSaveLogic = 'WebsiteNewSaveLogic',
  FormAutomationRules = 'FormAutomationRules',
}
